<template>
  <section data-nosnippet>
    <b-jumbotron id="kub-error-msg" header-tag="h2">
      <template #header>{{error.header}}</template>
      <template #lead>
        {{error.lead}} <b-icon :icon="error.icon"></b-icon>
      </template>
      <p>
        {{error.msg}}
      </p>
      <b-button class="kub-btn-filled" @click="reloadPage()">
        <b-icon :icon="error.btn.icon" class="mr-2" font-scale="1"></b-icon>
        <span>{{error.btn.text}}</span>
      </b-button>
    </b-jumbotron>
  </section>
</template>

<script>
import DataError from '../../data/general/errors'

export default {
  data () {
    return {
      error: DataError.error
    }
  },
  methods: {
    reloadPage () {
      window.location.reload()
    }
  }
}
</script>

<style>
  #kub-error-msg {
    height:100vh;
    background-color: rgba(0, 0, 0, 0.03);
  }
</style>
